import React from "react";
import { humanEUR } from "../../cost-control/forecast/format";
import { compactNumber } from "../format";

// Biggest movers — the section that makes this better than a usage dashboard.
// Rather than asking someone to read charts and work out what changed, it
// states what changed, by how much economically, and which of the two
// underlying quantities moved: how many requests, or how many tokens each one
// consumed. Same role as Biggest movers & drivers on Cost & Usage, so both
// pages are variations of one investigation workflow.

// Each quantity is signed and toned from ITS OWN value. Taking both signs
// from the token delta looked harmless until the two diverge — and the case
// where they diverge is the one this page exists to surface: a mix shift
// toward cheaper models lifts token volume while economic value falls, and
// that decline used to render as a positive number in green-or-red borrowed
// from the tokens. Rising cost is the danger tone here (this is a spend page),
// so an increase is red and a decrease green, per quantity.
function Quantity({ value, unit }) {
  const up = value >= 0;
  return (
    <span className={up ? "text-danger" : "text-success"}>
      {up ? "+" : "−"}
      {unit(Math.abs(value))}
    </span>
  );
}

function Swing({ tokens, value }) {
  return (
    <div className="text-[13px] tabular-nums">
      <Quantity value={tokens} unit={(v) => `${compactNumber(v)} tokens`} />
      <span className="text-text-3"> · </span>
      <Quantity value={value} unit={(v) => `${humanEUR(v)} API-equivalent`} />
    </div>
  );
}

export default function MoversPanel({ movers }) {
  const rows = movers || [];

  return (
    <div className="rounded-card border border-card-bd bg-card p-4">
      <div className="text-[15px] font-semibold text-text">Biggest movers &amp; drivers</div>

      {rows.length === 0 ? (
        <div className="py-12 text-center text-[13px] text-text-3">
          No material change against the comparison period.
        </div>
      ) : (
        <ul className="mt-3 flex flex-col gap-3">
          {rows.map((m) => (
            <li key={m.group} className="border-t border-card-bd pt-3 first:border-t-0 first:pt-0">
              <div className="text-[13px] font-semibold text-text">{m.group}</div>
              <Swing tokens={m.deltaTokens} value={m.deltaApiEquivalent} />
              <div className="text-[12px] text-text-3">{m.reason}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
